exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*!\n * Copyright (c) 2017 DV Bern AG, Switzerland\n *\n * Das vorliegende Dokument, einschliesslich aller seiner Teile, ist urheberrechtlich\n * geschuetzt. Jede Verwertung ist ohne Zustimmung der DV Bern AG unzulaessig. Dies gilt\n * insbesondere fuer Vervielfaeltigungen, die Einspeicherung und Verarbeitung in\n * elektronischer Form. Wird das Dokument einem Kunden im Rahmen der Projektarbeit zur\n * Ansicht uebergeben ist jede weitere Verteilung durch den Kunden an Dritte untersagt.\n *\n */.dv-schaeden-list .row-schadend-objekt{width:20%}.dv-schaeden-list .row-genauer-ort{width:30%}.dv-schaeden-list .row-datum-stichtag,.dv-schaeden-list .row-geschaetzte-kosten{width:20%}.dv-schaeden-list .row-actions{min-width:100px;width:10%}.dv-schaeden-list .green{color:#4ccb69}.dv-schaeden-list .yellow{color:#dcc100}.dv-schaeden-list .red{color:#bc2500}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/app/core/component/dv-schaden-list/dv-schaden-list.scss
// module id = 7xmh
// module chunks = 0